@import '../../assets/styles/variables';
@import '../../assets/styles/typography';
@import '../../../node_modules/@cpt/pci/postnl-styles/settings';
@import '../pnl-header/pnl-header.scss';

.pnl-header--desktop {
    background-color: $color-background-variant;

    @media (max-width: $bp-nav) {
        .pci-icon {
            margin: 0;
            padding: 0;
        }
    }
}

.pci-inner-container {
    height: 80px;
    display: flex;
    position: relative;
    align-items: center;
}

.pci-inner-container--alt {
    justify-content: flex-end;
    height: 2.5rem;
    position: static;

    .pci-flyout .pci-button {
        position: static;
    }
}

.pnl-navigation__link--replacement {
    width: 3.5em;
    height: 3.5em;
}

.pnl-focus-link {
    margin: unset;
}

.pnl-header__button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    color: $color-icon-button-secondary-default;
    font-size: 1rem;
    font-family: $font-family-bodytext, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: 'ss03' on, 'ss01' on;
    background: none;
    border: none;
    border-radius: 0.25rem;
    margin-left: auto;

    &:hover {
        text-decoration: underline;
        text-underline-offset: 0.15em;
    }

    &:focus:not(:focus-visible) {
        outline: none;
    }

    &:focus-visible {
        outline-color: $color-border-focus-outline;
        outline-style: solid;
        outline-width: 2px;
        outline-offset: 1px;
    }

    &:active {
        color: $color-border-focus-outline;
        text-decoration: underline;
        text-underline-offset: 0.15em;
        background-color: #ffffff00;

        > span svg path {
            fill: $color-border-focus-outline;
        }
    }
}

.pnl-header__button-icon {
    display: flex;
    align-items: center;
    height: 12px;
    width: 12px;

    > svg {
        path {
            fill: $color-icon-button-secondary-default;
        }
    }
}

.pnl-header__utility {
    position: relative;
    background-color: $color-background-variant;
}

.pnl-header__utility--focus {
    display: block;
}

.pnl-header__nav {
    display: flex;
    gap: 2.5rem;
    margin-left: auto;

    > ul {
        display: flex;
        align-items: center;
        list-style-type: none;
        margin: 0;
    }
}

.pnl-header__nav-item {
    max-block-size: 25px;
    border-right: 1px solid $color-border-default;
}

.pci-flyout__list {
    .pnl-header__nav-item & {
        width: unset !important;
        max-inline-size: 20vw;
    }

    .pnl-header__utility--focus & {
        left: -50% !important;
    }

    .pnl-user-menu__login & {
        right: -70% !important;
    }
}

// Overrides from widgets
.pnl-user-menu-container {
    .pnl-header & {
        margin-right: 0;
    }
}

.pnl-user-menu__simpleloginbutton {
    margin-left: auto !important;
}

.pnl-user-menu__simpleloginbutton {
    &.pci-flyout__trigger {
        margin-left: auto;
        min-width: unset;
        font-weight: 500;
        background-color: transparent;
    }

    .pnl-header & {
        padding: 0 1rem;
    }
}
